import { useTranslation } from "react-i18next";
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip } from "recharts";

export const COLORS = ["rgb(150, 150, 150)", "rgb(221, 221, 221)"];

const DeviceStats = ({ devices = [] }) => {
    const [t] = useTranslation(["global", "device"]);

    function getStatusColor(status) {
        switch (status) {
            case "CHARGING":
                return "rgb(13, 110, 253)";
            case "OFFBODY":
                return "rgb(255, 193, 7)";
            case "IN_USE":
                return "rgb(25, 135, 84)";
            case "STANDBY":
                return "rgba(98, 172, 182, 1)";
            case "DISABLED":
                return "rgb(220, 53, 69)";
            case "UNKNOWN":
            default:
                return "rgb(108, 117, 125)";
        }
    }



    // 🔹 funzione di mapping con localizzazione
    function buildChartData(devices, key, type) {
        if (!devices || devices.length === 0) return [];

        const total = devices.length;

        const counts = devices.reduce((acc, d) => {
            const k = d[key];
            acc[k] = (acc[k] || 0) + 1;
            return acc;
        }, {});

        return Object.entries(counts).map(([rawName, value]) => {
            const localizedName =
                type === "status"
                    ? t(`device:entity.device.smart_status.${rawName}`)
                    : t(`device:entity.device.type.${rawName}`);

            return {
                name: localizedName, // localizzato
                rawName, // manteniamo l’originale per colori
                value,
                percentage: `${((value / total) * 100).toFixed(1)}%`,
            };
        });
    }

    const dataByType = buildChartData(devices, "type", "type");
    const dataByStatus = buildChartData(devices, "smartStatus", "status");

    const renderPieChart = (data, type) => (
        <ResponsiveContainer width="100%" height={200}>
            <PieChart>
                <Pie
                    data={data}
                    dataKey="value"
                    nameKey="name"
                    cx="50%"
                    cy="50%"
                    stroke="#000000"
                    strokeOpacity={0.2}
                    strokeWidth={5}
                    outerRadius={60}
                    innerRadius={30}
                    label={({ name, percentage, value }) => `${name} ${value}`}
                >
                    {data.map((entry, index) =>
                        type === "type" ? (
                            <Cell key={index} fill={COLORS[index % COLORS.length]} />
                        ) : (
                            <Cell key={index} fill={getStatusColor(entry.rawName)} />
                        )
                    )}
                </Pie>
                <Tooltip formatter={(value) => `${value}`} />
            </PieChart>
        </ResponsiveContainer>
    );

    return (
        <div className={`container mt-4`}>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="mb-0 text-muted">{t("device:menu.devices_stats")}</h4>
            </div>

            <div className="row">
                <div className="col-md-2 mb-3">
                    <div className="card bg-dark text-bg-light">
                        <div className="card-body text-center">
                            <h6 className="card-subtitle mb-2 text-muted">
                                {t("device:label.total")}
                            </h6>
                            <h3 className="card-title">
                                {devices.length}
                            </h3>
                        </div>
                    </div>
                </div>
                <div className="col-md-5 mb-4">
                    <div className="text-bg-light h-100">
                        <div className="card-body text-center">
                            <h6 className="card-subtitle mb-2 text-muted">
                                {t("device:label.devices_by_status")}
                            </h6>
                            {renderPieChart(dataByStatus, "status")}
                        </div>
                    </div>
                </div>
                <div className="col-md-5 mb-5">
                    <div className="text-bg-light h-100">
                        <div className="card-body text-center">
                            <h6 className="card-subtitle mb-2 text-muted">
                                {t("device:label.devices_by_type")}
                            </h6>
                            {renderPieChart(dataByType, "type")}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeviceStats;
